import React, { useState } from 'react';
import PersonalDetails from './PersonalDetails';
import { AccountType, InvestorCustomTagCategory } from 'further-types/investor';
import EntityDetails from './EntityDetails';
import { InvestorCustomTagCategoryLabels } from 'further-ui/labels';
import api from 'lib/trpcClient';
import { InvestorFormValues } from 'helpers/investor/investorForm';
import { useFormContext } from 'react-hook-form';

type Props = {
  id?: string;
  accountType: AccountType;
  emailInUseByOtherAccount: boolean;
};

const tagCategoryOptions = Object.values(InvestorCustomTagCategory).map(
  (category) => ({
    label: InvestorCustomTagCategoryLabels[category],
    value: category,
  }),
);

const InvestorDetails: React.FC<Props> = ({
  id,
  accountType,
  emailInUseByOtherAccount,
}) => {
  const { watch } = useFormContext<InvestorFormValues>();
  const [tagCategory, setTagCategory] = useState<string>();
  const firmId = watch('firmId');

  const { data: tagData } = api.investor.listCustomTags.useQuery(
    {
      category: tagCategory,
      firmId,
    },
    {
      enabled: Boolean(tagCategory),
      staleTime: 1,
    },
  );

  const tagOptions = (tagData ?? []).map((tag) => tag.tag);

  return (
    <>
      {accountType === AccountType.LegalEntity ? (
        <EntityDetails
          id={id}
          tagCategoryOptions={tagCategoryOptions}
          emailInUseByOtherAccount={emailInUseByOtherAccount}
          onCategoryChange={setTagCategory}
          tagCategory={tagCategory}
          tagOptions={tagOptions}
        />
      ) : (
        <PersonalDetails
          id={id}
          tagCategoryOptions={tagCategoryOptions}
          emailInUseByOtherAccount={emailInUseByOtherAccount}
          tagOptions={tagOptions}
          onCategoryChange={setTagCategory}
          tagCategory={tagCategory}
        />
      )}
    </>
  );
};
export default InvestorDetails;
